'use client';

import { DialogTrigger, DrawerTrigger } from '@shared/ui';
import { useMobile } from '@shared/hooks';
import { useOtpContext } from '../model';

interface OtpTriggerProps {
  children: React.ReactNode;
}

export const OtpTrigger: React.FC<OtpTriggerProps> = ({ children }) => {
  const { resend, confirm } = useOtpContext();
  const isMobile = useMobile();

  const isDisabled = confirm.isPending || resend.isPending;

  const Trigger = isMobile ? DrawerTrigger : DialogTrigger;

  return (
    <Trigger disabled={isDisabled} asChild>
      {children}
    </Trigger>
  );
};
